// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Bnhh7","container__bees_icon":"styles_container__bees_icon__Vxdnf","container__footer":"styles_container__footer__G+oT6"};